import { citeTextDesc, citeTextList } from './descriptions/citeText'
import { easilyTextList, easyTextDesc } from './descriptions/easyText'
import {
  effortlesslyTextDesc,
  effortlesslyTextList,
} from './descriptions/effortlesslyText'
import { generateTextDesc, generateTextList } from './descriptions/generateText'
import { ieeeStyleTextDesc, ieeeTextList } from './descriptions/ieeeStyleText'
import { freeUseTextDesc, freeUseTextList } from './descriptions/freeUseText'

export const getStyleDesc = (style: string): string => {
  let message
  if (generateTextList.includes(style)) message = generateTextDesc(style.toUpperCase())
  else if (ieeeTextList.includes(style)) message = ieeeStyleTextDesc(style)
  else message = 'Not found'
  return message
}

const styleContainsIeee = (urlStyle: string) => {
  const parts = urlStyle.split('-')
  // Check if the urlStyle is a subset of ieee style
  return parts.includes('ieee')
}

export const getStyleSourceDesc = (style: string, source: string): string => {
  // removing the substyles inside ieee citation
  let formattedStyle = styleContainsIeee(style) ? 'ieee' : style

  // removing the cascading inside mla-8 style for all style variables
  const updatedStyle = style === 'mla-8' ? 'mla8' : style
  formattedStyle = formattedStyle === 'mla-8' ? 'mla8' : formattedStyle

  if (
    citeTextList.find(
      ([citeStyle, citeSource]) => citeStyle === updatedStyle && citeSource === source
    )
  )
    return citeTextDesc(formattedStyle.toUpperCase(), source)
  if (
    effortlesslyTextList.find(
      ([effortlesslyStyle, effortlesslySource]) =>
        effortlesslyStyle === updatedStyle && effortlesslySource === source
    )
  )
    return effortlesslyTextDesc(formattedStyle.toUpperCase(), source)
  if (
    freeUseTextList.find(
      ([useStyle, useSource]) => useStyle === updatedStyle && useSource === source
    )
  )
    return freeUseTextDesc(formattedStyle.toUpperCase(), source)
  if (
    easilyTextList.find(
      ([easilyStyle, easilySource]) =>
        easilyStyle === updatedStyle && easilySource === source
    )
  )
    return easyTextDesc(formattedStyle.toUpperCase(), source)
  return 'Not found'
}
